import { Injectable } from '@angular/core';
import { Observable, map, of, tap, zip } from 'rxjs';
import { LeadInjectorDto } from 'src/app/infrastructure/lobby-proxy/DTOs/lead-injector.dto';
import { LeadInjectorProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-lead-injector/lead-injector-proxy.service';
import { LeadInjectorDtoToLeadInjector } from 'src/app/shared/mappings/lead-model-dto/lead-injector.mapping';
import { AutocompleteStrategyBase, SearchSuggestion } from 'src/app/shared/ui-kit/inputs/autocomplete/search-strategy-base';
import { catchSoftNotFoundError } from 'src/app/shared/utils/functions/catch-soft-not-found-error.func';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteLeadInjectorIdSuggestionService extends AutocompleteStrategyBase {

  constructor(private readonly leadInjectorProxyService: LeadInjectorProxyService) {
    super()
  }

  override loadSuggestions$(text: string, maxSuggestions: number | undefined): Observable<SearchSuggestion[]> {

    return zip(
      this.leadInjectorProxyService.getLeadInjectors$(0, maxSuggestions, text, null),
      text ? this.leadInjectorProxyService.getLeadInjector$(text).pipe(catchSoftNotFoundError) : of(null)
    )
      .pipe(
        map(([search, single]) => {
          if (single?.data)
            search.data.unshift(single.data)
          return search
        }),
        throwIfLobbyErrorCode,
        map((dto => dto.data as LeadInjectorDto[])),
        tap(x => console.log('injector sugg', x)),
        map(injectors => injectors.map(injector => {
          console.log('selected', injector.leadInjectorId, injector.description)
          return { id: injector.leadInjectorId.toString(), value: this.formatInjectorName(injector) } as SearchSuggestion
        }))
      )
  }

  private formatInjectorName(injector: LeadInjectorDto): string {
    if (injector.description) return `${injector.description ?? ''} (${injector.leadInjectorId})`
    return injector.leadInjectorId.toString()
  }
}